export class BuildingsGroup {
    id: string;
    name: string;
    listOfBuildings: Array<string>;
}
